// Copyright (c) Microsoft. All rights reserved.

import React from 'react';
import { BotResponsePrompt, PromptSectionsNameMap } from '../../../../../libs/models/BotResponsePrompt';
import { IChatMessage } from '../../../../../libs/models/ChatMessage';
import { formatParagraphTextContent } from '../../../../utils/TextUtils';
import { ModalDialog } from '../Shared/ModalDialog';
import { TokenUsageGraph } from '../token-usage/TokenUsageGraph';

interface IPromptDialogProps {
    message: IChatMessage;
    open: boolean;
    onClose: () => void;
}

export const PromptDialog: React.FC<IPromptDialogProps> = ({ message, open, onClose }) => {
    let prompt: string | BotResponsePrompt;

    try {
        prompt = JSON.parse(message.prompt ?? '{}') as BotResponsePrompt;
    } catch {
        prompt = message.prompt ?? '';
    }

    let promptDetails;
    if (typeof prompt === 'string') {
        promptDetails = formatParagraphTextContent(prompt);
    } else {
        promptDetails = Object.entries(prompt).map(([key, value]) => {
            if (
                key === 'chatMemories' &&
                value &&
                !(value as string).includes('User has also shared some document snippets:')
            ) {
                value += '\nNo relevant document memories.';
            }

            return value && key !== 'metaPromptTemplate' ? (
                <div key={`prompt-details-${key}`}>
                    <h3 className="mb-2 font-semibold text-primary-900 dark:text-primary-200">
                        {PromptSectionsNameMap[key]}
                    </h3>
                    {formatParagraphTextContent(value as string)}
                </div>
            ) : null;
        });
    }

    return (
        <ModalDialog title={'Prompt details'} open={open} onClose={onClose}>
            <TokenUsageGraph promptView tokenUsage={message.tokenUsage ?? {}} />
            {promptDetails}
        </ModalDialog>
    );
};
